import NetworkException from '../errors/NetworkException';

//The request was not possible to make (No internet connection / Service is down)
export default () => {
  throw new NetworkException({
    errors: [
      {
        description: 'web.error.network_error',
      },
    ],
  });
};
